import { FC } from 'react';
import { Bell, Settings } from 'lucide-react';
import { getGreeting, formatDate } from './constants';
import { UserMenu } from './UserMenu';
import { ThemeToggle } from '../../../components/theme';
import type { TherapistDashboardSection } from '../../../types/therapist-dashboard.types';

interface HeaderProps {
  userName: string | undefined;
  userMenuOpen: boolean;
  onUserMenuToggle: () => void;
  onSectionChange: (section: TherapistDashboardSection) => void;
  onLogout: () => void;
}

export const Header: FC<HeaderProps> = ({
  userName,
  userMenuOpen,
  onUserMenuToggle,
  onSectionChange,
  onLogout,
}) => {
  return (
    <header className="bg-white dark:bg-slate-800 border-b border-gray-200 dark:border-slate-700 sticky top-0 z-20 shadow-sm">
      <div className="flex items-center justify-between px-4 md:px-6 lg:px-8 py-4">
        {/* Left Section - Greeting */}
        <div className="ml-12 lg:ml-0">
          <p className="text-base sm:text-xl font-semibold text-gray-900 dark:text-slate-100">
            Good {getGreeting()}, {userName?.split(' ')[0] || 'Therapist'}!
          </p>
          <p className="text-sm text-gray-600 dark:text-slate-400">{formatDate()}</p>
        </div>

        {/* Right Section */}
        <div className="flex items-center space-x-4">
          <ThemeToggle />

          {/* Notifications */}
          <button
            onClick={() => onSectionChange('notifications')}
            className="relative p-2 text-gray-600 dark:text-slate-400 hover:bg-gray-50 dark:hover:bg-slate-700 rounded-lg transition-colors"
          >
            <Bell className="w-6 h-6" />
          </button>

          {/* Settings */}
          <button
            onClick={() => onSectionChange('profile')}
            className="p-2 text-gray-600 dark:text-slate-400 hover:bg-gray-50 dark:hover:bg-slate-700 rounded-lg transition-colors"
          >
            <Settings className="w-6 h-6" />
          </button>

          {/* User Menu */}
          <UserMenu
            userName={userName}
            isOpen={userMenuOpen}
            onToggle={onUserMenuToggle}
            onSectionChange={onSectionChange}
            onLogout={onLogout}
          />
        </div>
      </div>
    </header>
  );
};
